import { MessageSender } from '../types';

interface MessageProps {
  text: string;
  sender: MessageSender;
  username?: string;
  modalities?: {
    [key: string]: {
      name: string;
    };
  };
}

export function Message({ text, sender, username, modalities }: MessageProps) {
  return (
    <div className={`message-container ${sender}`}>
      {username && <div className="message-username">{username}</div>}
      <div className={`message ${sender}`}>
        <div className="message-text">{text}</div>
        {modalities && Object.keys(modalities).length > 0 && (
          <div className="modalities">
            {Object.keys(modalities).map((modalityKey) => (
              <span key={modalityKey} className="modality-tag">
                {modalityKey}
              </span>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
